import {
  ClientAppEvent,
  TRACKING_SHEET_HOWDYGO_PUBLICATION_ID,
} from "constants/index";

import { HowdyGoDemoPage } from "../HowdyGoDemoPage";

interface TrackingSheetUpgradePageProps {
  isDemoParticipant?: boolean;
}

const DEMO_HEADLINE =
  "This is a sample tracking sheet so you can explore how Evotrux tracking works.";

export function TrackingSheetUpgradePage(props: TrackingSheetUpgradePageProps) {
  const { isDemoParticipant = false } = props;

  return (
    <HowdyGoDemoPage
      publicationId={TRACKING_SHEET_HOWDYGO_PUBLICATION_ID}
      event={ClientAppEvent.SHIPMENT_TRACKING_DATA_PAGE_DEMO_VIEWED}
      visitedUrl="/shippers/data/shipment-tracking"
      demoHeadline={DEMO_HEADLINE}
      isDemoParticipant={isDemoParticipant}
    />
  );
}
